export const CLEAR_START_DATE = 'CLEAR_START_DATE';
export const CLEAR_TOURISTS = 'CLEAR_TOURISTS';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_ADULTS_PARAMS = 'SET_ADULTS_PARAMS';
export const CLEAR_KIDS = 'CLEAR_KIDS';
export const SET_KIDS_PARAMS = 'SET_KIDS_PARAMS';
